import { create } from "zustand";

import type { AppUpdateKind } from "./types";

type AppUpdateStore = {
  update: AppUpdateKind;
  /** The banner was closed; the update still loads on the next page change. */
  dismissed: boolean;
  setUpdate: (update: AppUpdateKind) => void;
  dismiss: () => void;
};

export const useAppUpdateStore = create<AppUpdateStore>((set) => ({
  update: "none",
  dismissed: false,
  setUpdate: (update) => set({ update }),
  dismiss: () => set({ dismissed: true })
}));

/**
 * Whether moving from `from` to `to` should load the waiting build: a soft
 * update loads on a change of page, never on a search or hash change within
 * one, so a filter or an open panel does not reload under the user.
 */
export const reloadsOnNavigation = (
  update: AppUpdateKind,
  from: string,
  to: string
): boolean => update === "soft" && from !== to;
